function filterTransactionsByMonth(
  transactions: any,
  year: number,
  month: number,
) {
  const filterTransactionArray = transactions?.filter((transaction: any) => {
    const transactionDate = new Date(transaction?.createdAt);
    return (
      transactionDate.getFullYear() === year &&
      transactionDate.getMonth() === month - 1
    );
  });

  const totalTransactionAmount = filterTransactionArray
    ?.filter((transaction: any) => {
      return (
        transaction?.transaction_amount &&
        transaction?.status?.toLowerCase() === "success"
      );
    })
    ?.reduce((acc: any, curr: any) => acc + curr.transaction_amount, 0);

  return {
    month,
    transactionCount: filterTransactionArray?.length,
    totalTransactionAmount,
  };
}

function filterTransactionsByQuarter(
  transactions: any,
  year: number,
  quarter: number,
) {
  const startMonth = (quarter - 1) * 3;
  const endMonth = startMonth + 2;

  const filterTransactionArray = transactions?.filter((transaction: any) => {
    const transactionDate = new Date(transaction.createdAt);
    const transactionMonth = transactionDate.getMonth();
    return (
      transactionDate.getFullYear() === year &&
      transactionMonth >= startMonth &&
      transactionMonth <= endMonth
    );
  });

  const totalTransactionAmount = filterTransactionArray
    ?.filter((transaction: any) => {
      return (
        transaction?.transaction_amount &&
        transaction?.status?.toLowerCase() === "success"
      );
    })
    ?.reduce((acc: any, curr: any) => acc + curr.transaction_amount, 0);
  return {
    quarter,
    transactionCount: filterTransactionArray?.length,
    totalTransactionAmount,
  };
}

function formatNumber(num: number) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + "B";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
}

function sumTransactionAmountOfToday(transactions: any) {
  let sum: any = 0;
  let count: any = 0;
  transactions?.forEach((transaction: any) => {
    if (transaction.status?.toLowerCase() === "success") {
      const dateOfTransaction = new Date(transaction?.createdAt).toLocaleString(
        "en-US",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        },
      );

      const todaysDate = new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      if (dateOfTransaction === todaysDate) {
        count++;
        sum = sum + transaction.transaction_amount;
      }
    }
  });
  return { sum, count };
}
function getSettlementAmount(settlements: any[]) {
  if (!settlements?.length) return 0;

  const latestDate = new Date(settlements[0].settlementDate)
    .toISOString()
    .split("T")[0];

  return settlements
    .filter(
      (item) =>
        new Date(item.settlementDate).toISOString().split("T")[0] ===
          latestDate && ["Settled", "SUCCESS"].includes(item.status),
    )
    .reduce((sum, item) => sum + (item.netSettlementAmount || 0), 0);
}
function getRecentTransactions(transactions: any) {
  let recenetTransactions = [];
  for (
    let i = 0;
    i < transactions?.length && recenetTransactions?.length < 10;
    i++
  ) {
    if (transactions?.[i]?.status.toLowerCase() === "success") {
      recenetTransactions.push(transactions?.[i]);
    }
  }
  return recenetTransactions;
}
export {
  filterTransactionsByMonth,
  filterTransactionsByQuarter,
  sumTransactionAmountOfToday,
  getSettlementAmount,
  formatNumber,
  getRecentTransactions,
};
